import { render, staticRenderFns } from "./DevFooter.vue?vue&type=template&id=545ab6ec&"
import script from "./DevFooter.vue?vue&type=script&lang=js&"
export * from "./DevFooter.vue?vue&type=script&lang=js&"
import style0 from "./DevFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports